import api from "./api";

// Conexiones de correo (doc 0445). La contraseña de aplicación viaja solo al probar, crear o cambiarla;
// el backend la guarda cifrada y nunca la devuelve.
export const testMailbox = (payload) => api.post("/email-channel/test", payload);
export const createEmailConnection = (payload) => api.post("/email-channel/connections", payload);
export const getEmailConnection = (whatsAppId) => api.get(`/email-channel/connections/${whatsAppId}`);
export const updateEmailConnection = (whatsAppId, payload) => api.put(`/email-channel/connections/${whatsAppId}`, payload);
export const testSavedMailbox = (whatsAppId) => api.post(`/email-channel/connections/${whatsAppId}/test`);

// Correos del SISTEMA (doc 0445 E4b): el buzón por el que salen las alertas y la recuperación de
// contraseña, y sus plantillas. Solo superadmin.
export const getSystemMailbox = () => api.get("/email-channel/system-mailbox");
export const setSystemMailbox = (whatsappId) => api.put("/email-channel/system-mailbox", { whatsappId });
export const listEmailTemplates = () => api.get("/email-channel/templates");
export const getEmailTemplate = (id) => api.get(`/email-channel/templates/${id}`);
export const updateEmailTemplate = (id, payload) => api.put(`/email-channel/templates/${id}`, payload);
export const testEmailTemplate = (id, to) => api.post(`/email-channel/templates/${id}/test`, { to });
// FormData: Para, Asunto, Mensaje, CC/CCO y los adjuntos en «medias» (doc 0449 §4).
export const composeEmail = (formData) => api.post("/email-channel/compose", formData);
